import { SVGFC } from '@repo/toolkit/types'

const SheetOutlineIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.66699 9.35C3.66699 6.23893 3.66699 4.68297 4.62196 3.7169C5.5761 2.75 7.11284 2.75 10.1855 2.75H11.8151C14.8878 2.75 16.4245 2.75 17.3787 3.7169C18.3337 4.68297 18.3337 6.23893 18.3337 9.35V12.65C18.3337 15.7611 18.3337 17.317 17.3787 18.2831C16.4245 19.25 14.8878 19.25 11.8151 19.25H10.1855C7.11284 19.25 5.5761 19.25 4.62196 18.2831C3.66699 17.317 3.66699 15.7611 3.66699 12.65V9.35Z"
        stroke={color || '#EA7203'}
        strokeWidth="1.28333"
      />
      <path
        d="M7.74121 9.35156H14.2597M7.74121 12.6516H11.8153"
        stroke={color || '#EA7203'}
        strokeWidth="1.28333"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default SheetOutlineIcon
